import { render, staticRenderFns } from "./PreviewMultiplechoiceModule.vue?vue&type=template&id=c762601c&scoped=true&"
import script from "./PreviewMultiplechoiceModule.vue?vue&type=script&lang=js&"
export * from "./PreviewMultiplechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMultiplechoiceModule.vue?vue&type=style&index=0&id=c762601c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c762601c",
  null
  
)

export default component.exports